import FetchHelper from './FetchHelper'

import moment from 'moment'
import Notify from "./Notify";
import Currency from "./Currency";
import {ca} from "date-fns/locale";

let cart = null
let fkCart = null

const DEFAULT_CART = {
  items: [],
  subtotal: 0,
  campaign: null
}

export default class Cart {
  static init() {
    if (Cart.localCart == null) {
      let localCart = localStorage.getItem('cart')
      localCart = localCart ? JSON.parse(localCart) : {...DEFAULT_CART}
      Cart.localCart = localCart

      let items = Cart.localCart.items
      Cart.resetCC();
      let cartTotal = this.processCartItems(items);
      Cart.localCart.subtotal = cartTotal;
    }

    Cart.save()
    return Cart.localCart
  }

  static get() {
    if (Cart.cart == null) {
      let cart = sessionStorage.getItem('fkCart')
      cart = cart ? JSON.parse(cart) : {}
      Cart.cart = cart
    }
    return Cart.cart
  }

  static getLocalCart() {
    if (Cart.localCart == null) {
      let cart = localStorage.getItem('cart')
      cart = cart ? JSON.parse(cart) : {}
      Cart.localCart = cart
    }
    return Cart.localCart
  }

  static getCCItems() {
    if (Cart.cart == null) {
      let cart = sessionStorage.getItem('fkCart')
      cart = cart ? JSON.parse(cart) : {}
      Cart.cart = cart
    }
    if (Cart.subscribeCart == null) {
      let subscribeCart = sessionStorage.getItem('rebillCart')
      subscribeCart = subscribeCart ? JSON.parse(subscribeCart) : {}
      Cart.subscribeCart = subscribeCart
    }
    if (Cart.customMessage == null) {
      let customMessage = sessionStorage.getItem('customCart')
      customMessage = customMessage ? JSON.parse(customMessage) : {}
      Cart.customMessage = customMessage
    }

    return [Cart.cart, Cart.subscribeCart, Cart.customMessage]
  }

  static processCartItems(items) {
    let [fkCart, rebillCart, customCart] = Cart.getCCItems();
    let cartTotal = 0;

    items.forEach(item => {
      fkCart[item.ccCartKey] = item.quantity + (fkCart[item.ccCartKey] || 0)
      if(item.frequency && item.product.hasSubscriptionOptions){
        rebillCart[item.ccCartKey] = item.frequency
      }

      if (item.customMessage.length > 0) {
        const existingEntry = Object.entries(customCart).find(entry =>
          entry[1].includes(item.ccCartKey) && entry[1].includes(item.customMessage.join("|"))
        );

        let customCartKey = Object.keys(customCart).length;
        if (existingEntry) {
          customCartKey = parseInt(existingEntry[0]);
        }

        customCart[customCartKey] = `${item.ccCartKey}|${item.quantity}|${item.customMessage.join("|")}`;
      }

      cartTotal += item.total;
    });

    return cartTotal;
  }

  static async add(product, variant, customMessageOptions, quantity, frequency) {
    Cart.resetCC();

    let localCart = Cart.getLocalCart();

    if(!localCart.campaign){
      localCart.campaign = window.CURRENT_CAMPAIGN
    }

    let items = localCart.items;

    const price = variant?.price || product.price;
    const itemKey = variant ? `${product.campaignProductId}.${variant.variantDetailId}` : `${product.campaignProductId}`;

    const existingItemIndex = items.findIndex(item => item.ccCartKey === itemKey && item.customMessage.join("|") === customMessageOptions.join("|"));

    if(existingItemIndex > -1 && frequency && (items[existingItemIndex].frequency !== frequency)){
      Notify.error("Failed to add to cart. This item exists in the cart already with a different frequency");

      let cartTotal = this.processCartItems(items);

      localCart.subtotal = cartTotal;
      Cart.save();

      return Cart.localCart;
    }

    let cartItem = {
      product: product,
      ccCartKey: itemKey,
      quantity,
      customMessage: [...customMessageOptions],
      total: parseFloat((parseFloat(price) * quantity).toFixed(2)),
      frequency
    };

    if (existingItemIndex > -1) {
      items[existingItemIndex].quantity += 1;
      items[existingItemIndex].total = parseFloat((parseFloat(price) * items[existingItemIndex].quantity).toFixed(2));
    } else {
      items.push({...cartItem});
    }

    let cartTotal = this.processCartItems(items);

    localCart.subtotal = cartTotal;
    Cart.save();

    return Cart.localCart;
  }

  static async remove(product, variant, customMessageOptions, quantity, frequency) {
    Cart.resetCC();

    let localCart = Cart.getLocalCart();
    let items = localCart.items;

    const price = variant?.price || product.price;
    const itemKey = variant ? `${product.campaignProductId}.${variant.variantDetailId}` : `${product.campaignProductId}`;

    const itemIndex = items.findIndex(item => item.ccCartKey === itemKey && item.customMessage.join("|") === customMessageOptions.join("|") && item.frequency === frequency);

    if (itemIndex > -1) {
      items[itemIndex].quantity -= quantity;

      if (items[itemIndex].quantity > 0) {
        items[itemIndex].total = parseFloat((parseFloat(price) * items[itemIndex].quantity).toFixed(2));
      } else {
        items.splice(itemIndex, 1);
      }
    }

    let cartTotal = this.processCartItems(items);

    localCart.subtotal = cartTotal;
    Cart.save();

    return Cart.localCart;
  }

  static async set(product, variant, quantity){

    let cart = Cart.get();
    let item = cart.items.find(eItem => Cart.isMatch(product, variant, eItem))

    if (!item) {
      return
    }
    let oldQuantity = item.quantity
    item.quantity = quantity
    let index = cart.items.findIndex(item => Cart.isMatch(product, variant, item))
    if(quantity == 0){
      try{
        let response = await Cart._unreserveCartItem(item)
      }
      catch(error){
        item.quantity = oldQuantity
        throw error
      }
      cart.items.splice(index, 1)
    }
    else{
      try{
        let response = await Cart._reserveCartItem(item)
      }
      catch(error){
        item.quantity = oldQuantity
        throw error
      }
    }

    cart.subtotal = Cart._calculateSubtotal()
    cart.shipping_price = Cart._calculateShippingPrice()

    Cart.save()
    return Cart.cart
  }

  static save() {
    localStorage.setItem('cart', JSON.stringify(Cart.localCart))
    sessionStorage.setItem('fkCart', JSON.stringify(Cart.cart))
    sessionStorage.setItem('rebillCart', JSON.stringify(Cart.subscribeCart))
    sessionStorage.setItem('customCart', JSON.stringify(Cart.customMessage))
  }

  static async addCoupon(coupon){
    let cart = Cart.get()
    cart.coupon = coupon
    Cart.save()
    return Cart.cart
  }

  static reset() {
    Cart.localCart = { ...DEFAULT_CART }
    Cart.save()
    return Cart.localCart
  }

  static resetCC () {
    const ccCartKeys = ['fkCart', 'rebillCart', 'customCart'];

    ccCartKeys.forEach(key => sessionStorage.setItem(key, JSON.stringify({})));

    Cart.cart = null
    Cart.subscribeCart = null
    Cart.customMessage = null
  }

  static _calculateSubtotal(){
    let price = 0

    Cart.cart.items.forEach((item, i) => {
      if(item.product.on_sale){
        price += item.variant ? item.variant.price * item.quantity : item.product.sale_price * item.quantity
      }
      else{
        price += item.variant ? item.variant.price * item.quantity : item.product.price * item.quantity
      }
    });

    return price
  }

  static _calculateShippingPrice(){
    let shippingPrice = 0

    Cart.cart.items.forEach((item, i) => {
      shippingPrice += item.product.shipping_price * item.quantity
    });

    if(Cart.cart.shop.shipping_fees_type === "flat"){
      shippingPrice = Cart.cart.shop.flat_shipping_fee || 0
    }

    return shippingPrice
  }

  static getTotalItemsNo(){
    let cart = Cart.localCart
    if(cart.items.length < 1) return 0
    return cart.items.reduce((total, item) => {
      return total + item.quantity
    }, 0)
  }

  static isMatch(product, variant, item){
    let productMatch = item.product.id == product.id
    if(item.variant == null && variant == null){
      return productMatch
    }
    else if(item.variant != null && variant != null){
      return productMatch && item.variant.id == variant.id
    }
    return false
  }

  static async _reserveCartItem(item){

    if(!Cart.cart.shop.stock_enabled || !Cart.cart.shop.reservation_delta){
      return item
    }

    let response = null
    if(item.cart_item_uuid){
      try {
        response = await FetchHelper.patch(`${window.Api.CartItems}/${item.cart_item_uuid}`, {
          quantity: item.quantity,
        }, true, false)
      }
      catch(error) {
        throw error
      }
    }
    else{
      let data = {
        quantity: item.quantity,
        product: item.product.id
      }

      if(item.variant){
        data["product_variant"] = item.variant.id
      }

      try {
        response = await FetchHelper.post(`${window.Api.CartItems}`, data, false, false)
      }
      catch(error){
        throw error
      }
    }

    item.cart_item_uuid = response.uuid
    item.release_at = response.release_at
  }

  static async _unreserveCartItem(item){

    let response = null
    if(!item.cart_item_uuid){
      return
    }

    try {
      response = await FetchHelper.delete(`${window.Api.CartItems}/${item.cart_item_uuid}`, {}, false)
    }
    catch(error) {
      throw error
    }

    item.cart_item_uuid = null
    item.release_at = null
  }

  static outOfStock(product, selectedOptions){
    let shop = Cart.cart?.shop
    let availableOptions = Cart.getOptions(product)
    let availableOptionsNo = Object.entries(availableOptions).length
    if(shop && !shop.stock_enabled){
      return false
    }

    let cloneSelectedOptions = selectedOptions ? Array.from(selectedOptions) : []
    let cloneProduct = JSON.parse(JSON.stringify(product))

    if(cloneSelectedOptions.length < 1 || availableOptionsNo < 1){
      return parseInt(cloneProduct.stockQuantity) <= 0
    }

    let variant = cloneProduct.variants.find(productVariant => {
      return productVariant.title === cloneSelectedOptions.sort().join(' / ')
    })

    if(variant.title.split(" / ").length < availableOptionsNo){
      return false
    }

    return parseInt(variant.stockQuantity) <= 0
  }

  static showAddToCart(product, selectedOptions){
    let variantsNo = product.variants.length
    let availableOptions = Cart.getOptions(product)
    let availableOptionsNo = Object.entries(availableOptions).length

    let showAddToCart = true

    if (variantsNo > 0){
      showAddToCart = false
      let selectedOptionsNo = selectedOptions.reduce((total, option) => {
        return option != null ? total + 1 : total;
      }, 0);
      showAddToCart = selectedOptionsNo === availableOptionsNo
    }

    return showAddToCart
  }

  static getOptions(product){
    let options = {};

    if(!product){
      return null
    }

    product.variants.forEach(variant => {
      for (let i = 1; i <= 3; i++) {
        const variantName = variant[`variantName${i}`];
        const variantOption = variant[`variantOptionName${i}`];

        if (variantName && variantOption) {
          if (!options[variantName]) {
            options[variantName] = new Set();
          }
          options[variantName].add(variantOption);
        }
      }
    })

    for (const variantName in options) {
      options[variantName] = Array.from(options[variantName]);
    }

    return options
  }

  static selectDefaultVariant(product){

    if(!product || product.variants.length === 0){
      return []
    }

    let defaultVariant = product.variants[0]
    let selectedVariant = []

    for (let i = 1; i <= 3; i++) {
      const variantOption = defaultVariant[`variantOptionName${i}`];

      if (variantOption) {
        selectedVariant.push(variantOption)
      }
    }

    return selectedVariant
  }

  static getCustomMessageOptions(product){
    let options = []

    if(!product){
      return null
    }

    if(product.customMessageOptions){
      return product.customMessageOptions.split(",")
    }

    return options
  }

  static getVariant(product, selectedOptions){
    let cloneSelectedOptions = Array.from(selectedOptions)
    let cloneProduct = JSON.parse(JSON.stringify(product))

    if(cloneProduct.variants.length < 1){
      return null
    }

    return cloneProduct.variants.find(productVariant => {
      return productVariant.title === cloneSelectedOptions.sort().join(' / ')
    })
  }

  static getLastVariantPriceInfo(product, selectedVariant, variantNameNumber) {
    const variants = product?.variants;
    if (!variants?.length) {
      return {}
    }
    const details = {}
    variants.forEach((variant) => {
      const variantOptionName = variant["variantOptionName" + variantNameNumber]
      let variantFound = 0;
      selectedVariant.forEach((x, i) => {
          const index = i + 1;
          if (index !== variantNameNumber && x === variant["variantOptionName" + index]) {
            variantFound += 1
          }
      })
      if (variantOptionName && selectedVariant.length - 1 == variantFound) {
        details[variantOptionName] = {
          price: Number(variant.price) || 0,
          compareAtPrice: Number(variant.compareAtPrice) || 0
        }
      }
    })
    let oneValidCompareAtPrices = false
    for (let i in details) {
      const obj = details[i]
      if (obj.compareAtPrice && obj.compareAtPrice > obj.price) {
        oneValidCompareAtPrices = true
        break
      }
    }
    return {
      pricesObj: details,
      oneValidCompareAtPrices
    }
  }

  static applyCoupon(subtotal, coupon, currency){
    let value = 0
    let couponText = ''
    if(coupon.type === "percentage"){
      let amountOff = ((subtotal * coupon.amount) / 100)
      value = amountOff
      couponText = `- ${Currency.format(amountOff, currency)}`
    }else if(coupon.type === "fixed_amount"){
      if(subtotal > 0){
        value = coupon.amount
        couponText = `- ${Currency.format(coupon.amount, currency)}`
      }
    }
    return {value, couponText}
  }

  static isCouponValid(subtotal, coupon){
    if(coupon.min_threshold){
      if(coupon.min_threshold > subtotal){
        return false
      }
    }
    if(coupon.max_threshold){
      if(coupon.max_threshold < subtotal){
        return false
      }
    }
    return true
  }

  static getProductImagesByVariantNameNumber(product, variantNameNumber, selectedVariant){
    const obj = {}
    const variants = product?.variants;
    if (!variants.length || !variantNameNumber || variantNameNumber < 1 || variantNameNumber > 3){
      return obj
    }
    variants.forEach((variant) => {
      const variantOptionName = variant["variantOptionName" + variantNameNumber]
      let variantFound = 0;
      selectedVariant.forEach((x, i) => {
          const index = i + 1;
          if (index !== variantNameNumber && x === variant["variantOptionName" + index]) {
            variantFound += 1
          }
      })
      if (variantOptionName && selectedVariant.length - 1 == variantFound) {
        const variantName = obj[variantOptionName]
        if (!variantName || variantName) {
          obj[variantOptionName] = variant.imageUrl
        }
      }
    })
    return obj
  }

  static getProductMetaData(product){
    return product?.metaFields?.filter((o) => {
      return !o?.name?.toLowerCase().startsWith("storefront-")
    }) || []
  }

  static getProductBadgeData(product){
    return product?.metaFields?.filter((o) => {
      return o?.name?.toLowerCase()?.startsWith("storefront-badge")
    }) || []
  }
}
